// export const API_BASE = 'http://192.168.178.100:8000/api'
// export const API_URL = 'http://192.168.178.100:8000/api/pwa'
// export const IMG_URL = 'http://192.168.178.100:8000/uploaded_files/'
// export const PLACEHOLDER_IMG = 'http://192.168.178.100:8000/placeholder.png'

// export const API_BASE = 'http://localhost:8000/api'
// export const API_URL = 'http://localhost:8000/api/pwa'
// export const IMG_URL = 'http://localhost:8000/uploaded_files/'
// export const PLACEHOLDER_IMG = 'http://localhost:8000/placeholder.png'

export const API_BASE = 'https://api-staging.aislenine.co.nz/api'
export const API_URL = 'https://api-staging.aislenine.co.nz/api/pwa'
export const IMG_URL = 'https://api-staging.aislenine.co.nz/uploaded_files/'
export const PLACEHOLDER_IMG = 'https://api-staging.aislenine.co.nz/placeholder.png'

export const requestHeader = () => {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
    } 
}

